"use client";
import { cn } from "@lib/utils";
// import { useRequestAnimationFrame } from "@hooks/useRequestAnimationFrame";
import { useRef } from "react";

// const MOVEMENT_THRESHOLD = 10; // pixels
// const VELOCITY_THRESHOLD = 0.5; // pixels per millisecond
// const TRANSITION_DURATION = 300; // milliseconds
// const ON_CLOSE_THRESHOLD = 0.5; // percentage

interface TransitionViewProps extends React.HTMLAttributes<HTMLDivElement> {
  trigger: boolean; // Show/hide the view
  onCloseThreshold?: number; // Percentage of the view visible to trigger close
  onClose?: () => void; // Callback when the view is closed
}

// interface TouchState {
//   startX: number;
//   startY: number;
//   currentX: number;
//   lastTimestamp: number;
//   velocity: number;
//   isScrolling: boolean;
//   initialScrollTop: number;
// }

export default function TransitionView({
  trigger,
  onCloseThreshold,
  onClose,
  className,
  ...props
}: TransitionViewProps) {
  // const { scheduleRAF, cancelRAF } = useRequestAnimationFrame();

  const viewRef = useRef<HTMLDivElement>(null);
  // const touchState = useRef<TouchState>({
  //   startX: 0,
  //   startY: 0,
  //   currentX: 0,
  //   lastTimestamp: 0,
  //   velocity: 0,
  //   isScrolling: false,
  //   initialScrollTop: 0,
  // });
  // const isAnimatingRef = useRef(false);

  // const findScrollableParent = (
  //   element: HTMLElement | null,
  // ): HTMLElement | null => {
  //   if (!element) return null;

  //   const isScrollable = (el: HTMLElement) => {
  //     const style = window.getComputedStyle(el);
  //     const overflowY = style.getPropertyValue("overflow-y");
  //     return overflowY === "scroll" || overflowY === "auto";
  //   };

  //   // Traverse up the DOM until we find a scrollable parent or reach the root
  //   while (element) {
  //     if (isScrollable(element)) {
  //       return element;
  //     }

  //     // Stop at the main panel or the root of the scrollable context
  //     if (element === viewRef.current) {
  //       return null;
  //     }

  //     element = element.parentElement;
  //   }

  //   return null;
  // };

  // useEffect(() => {
  //   // TODO: Add transition effect
  //   // TODO: Add opacity effect
  //   // TODO: Better trigger handling

  //   // Prevent interaction if viewRef is not available
  //   if (!viewRef.current) return;

  //   if (trigger) {
  //     viewRef.current.style.transition = `transform ${TRANSITION_DURATION}ms ease, opacity ${TRANSITION_DURATION}ms ease`;
  //     viewRef.current.style.transform = `translate3d(0, 0, 0)`; // Use translate3d for GPU acceleration
  //     // viewRef.current.style.opacity = "1"; // Fade in as it moves in
  //   } else {
  //     viewRef.current.style.transition = `transform ${TRANSITION_DURATION}ms ease, opacity ${TRANSITION_DURATION}ms ease`;
  //     viewRef.current.style.transform = `translate3d(100%, 0, 0)`; // Use translate3d for GPU acceleration
  //     // viewRef.current.style.opacity = "0"; // Fade out as it moves out
  //   }
  // }, [trigger]);

  // // Temporary disable touch handlers

  // const touchHandlers = {
  //   touchStart: (e: TouchEvent) => {
  //     // Cancel any pending animation frames
  //     cancelRAF();

  //     // Prevent interaction if viewRef is not available
  //     if (!viewRef.current) return;

  //     // Prevent interaction during animation
  //     if (isAnimatingRef.current) return;

  //     // Reset the animation flag
  //     isAnimatingRef.current = false;

  //     // Disable transition timing during interaction
  //     viewRef.current.style.transitionDuration = "";

  //     // Get the first touch
  //     const touch = e.touches[0];
  //     // Get the target element
  //     const target = e.target as HTMLElement;
  //     // Find the scrollable parent
  //     const scrollableParent = findScrollableParent(target);

  //     // Initialize touch state
  //     touchState.current = {
  //       startX: touch.clientX,
  //       startY: touch.clientY,
  //       currentX: touch.clientX,
  //       lastTimestamp: performance.now(),
  //       velocity: 0,
  //       isScrolling: false,
  //       initialScrollTop: scrollableParent?.scrollTop ?? 0,
  //     };
  //   },

  //   touchMove: (e: TouchEvent) => {
  //     // Prevent interaction if viewRef is not available
  //     if (!viewRef.current) return;
  //     // Prevent interaction during animation
  //     if (isAnimatingRef.current) return;

  //     // Get the first touch
  //     const touch = e.touches[0];
  //     // Get the touch state
  //     const state = touchState.current;

  //     // Detect movement direction
  //     if (!state.isScrolling) {
  //       // Calculate horizontal movement
  //       const deltaX = Math.abs(touch.clientX - state.startX);
  //       // Calculate vertical movement
  //       const deltaY = Math.abs(touch.clientY - state.startY);

  //       // Lock to vertical scrolling
  //       if (deltaY > deltaX && deltaY > MOVEMENT_THRESHOLD) {
  //         state.isScrolling = true;
  //         return;
  //       }

  //       // Lock to horizontal swiping
  //       if (deltaX > deltaY && deltaX > MOVEMENT_THRESHOLD) {
  //         state.isScrolling = false;

  //         // Prevent vertical scroll
  //         e.preventDefault();
  //         // Stop event bubbling
  //         e.stopPropagation();
  //       }
  //     }

  //     // If locked to vertical scrolling, ignore horizontal swipes
  //     if (state.isScrolling) {
  //       return;
  //     }

  //     // Continue with horizontal swipe handling...

  //     // Calculate horizontal movement
  //     const deltaX = touch.clientX - state.currentX;
  //     // Calculate time difference
  //     const deltaTime = performance.now() - state.lastTimestamp;

  //     //  Calculate/update velocity
  //     state.velocity = Math.max(-1, Math.min(1, deltaX / deltaTime));
  //     // Update current X position
  //     state.currentX = touch.clientX;
  //     // Update last timestamp
  //     state.lastTimestamp = performance.now();

  //     // Update the view position
  //     scheduleRAF(() => {
  //       // Calculate the offset
  //       const offset = touch.clientX - state.startX;
  //       const bounded = Math.max(0, offset); // Prevent negative offsets
  //       // Update the view position
  //       if (viewRef.current) {
  //         viewRef.current.style.transform = `translate3d(${bounded}px, 0, 0)`; // Use translate3d for GPU acceleration
  //       }
  //     });
  //   },

  //   touchEnd: () => {
  //     // Prevent interaction during animation
  //     if (isAnimatingRef.current) return;

  //     // Get the touch state
  //     const state = touchState.current;

  //     // Prevent interaction if viewRef is not available
  //     if (!viewRef.current) return;

  //     // Get the element width
  //     const elementWidth = viewRef.current.offsetWidth;
  //     // Calculate the current offset
  //     const currentOffset = state.currentX - state.startX;
  //     // Calculate the percentage visible
  //     const percentageVisible = Math.max(
  //       0,
  //       Math.min(1, 1 - currentOffset / elementWidth)
  //     );

  //     // Check if the percentage visible is less than the threshold
  //     if (
  //       percentageVisible < (onCloseThreshold || ON_CLOSE_THRESHOLD) ||
  //       state.velocity > VELOCITY_THRESHOLD
  //     ) {
  //       scheduleRAF(() => {
  //         if (viewRef.current) {
  //           viewRef.current.style.transform = `translate3d(100%, 0, 0)`;
  //           viewRef.current.style.opacity = "0"; // Fade out as it moves out
  //         }
  //       });

  //       onClose?.();
  //     } else {
  //       scheduleRAF(() => {
  //         if (viewRef.current) {
  //           viewRef.current.style.transform = `translate3d(0, 0, 0)`;
  //           viewRef.current.style.opacity = "1"; // Fade in as it moves back
  //         }
  //       });
  //     }
  //   },
  // };

  // useEffect(() => {
  //   const element = viewRef.current;
  //   if (!element) return;

  //   // Add non-passive event listeners
  //   element.addEventListener("touchstart", touchHandlers.touchStart, {
  //     passive: false,
  //   });
  //   element.addEventListener("touchmove", touchHandlers.touchMove, {
  //     passive: false,
  //   });
  //   element.addEventListener("touchend", touchHandlers.touchEnd, {
  //     passive: false,
  //   });

  //   // Cleanup
  //   return () => {
  //     element.removeEventListener("touchstart", touchHandlers.touchStart);
  //     element.removeEventListener("touchmove", touchHandlers.touchMove);
  //     element.removeEventListener("touchend", touchHandlers.touchEnd);
  //     cancelRAF();
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [touchHandlers]);

  return (
    <div
      ref={viewRef}
      className={cn(
        "TransitionView",
        // Mobile-first styles. Positioned (not padded) below the iOS status
        // bar: this container and its children are absolutely positioned, so
        // #Main's safe-area padding never reaches them — an inset-0 child of
        // a padded box still starts at the padding-box top, i.e. under the
        // clock, where taps go to the OS (unclickable back chevron on fresh
        // black-translucent webclips).
        "backface-hidden absolute top-[env(safe-area-inset-top,0px)] z-50 h-[calc(100%-env(safe-area-inset-top,0px))] w-screen touch-pan-x overflow-hidden will-change-transform",
        // Desktop styles
        "lg:relative lg:top-0 lg:h-full lg:flex-grow lg:transform-none",
        trigger ? "left-0 lg:block" : "left-full lg:hidden",
        className,
      )}
      {...props}
    />
  );
}
